import React, { useState } from "react";

// State Schema for Decks
export const fixedState = {
    deckStructure: {
        deckDirection: ["Horizontal", "Vertical"],
        deckAttachment: ["Masonry", "Timber"],
        deckShape: ["Rectangle / Square", "L Shape"],
        widthA: 0,
        widthB: 0,
        lengthA: 0,
        lengthB: 0,
        deckRotation: 0,
        deckHeight: 500,
        deckFreestanding: false,
    },
    designer: {
        showPopup: false,
        accepted: false,
    },
    deckMaterial: [
        "300mm (Softwood)",
        "450mm (Hardwood / Wood-Plastic Composite)",
        "600mm (Fibre Cement Sheet & tile)",
    ],
    deckAttachments: { rect1: {}, rect2: {} },
    deckFooting: "",
    finished: false,
};

// State handler for decks
export function useDeckState(initialState) {
    const [deckState, setDeckState] = useState(initialState);

    function validateProperties(expected, actual, path = "") {
        for (const key in expected) {
            const newPath = path ? `${path}.${key}` : key;

            if (typeof actual[key] === "undefined") {
                console.error(`State property "${newPath}" is missing in the new state.`);
                return false;
            }

            if (Array.isArray(expected[key])) {
                if (!Array.isArray(actual[key]) && !expected[key].includes(actual[key])) {
                    console.error(`Invalid value for property "${newPath}".`);
                    return false;
                }
            } else if (typeof expected[key] === "object") {
                if (typeof actual[key] !== "object") {
                    console.error(`Invalid type for property "${newPath}".`);
                    return false;
                }

                if (!validateProperties(expected[key], actual[key], newPath)) {
                    return false;
                }
            } else {
                if (typeof actual[key] !== typeof expected[key]) {
                    console.error(`Invalid type for property "${newPath}".`);
                    return false;
                }
            }
        }

        return true;
    }

    const updateDeckState = (newState) => {
        if (validateProperties(fixedState, newState)) {
            setDeckState(newState);
        }
    };

    return [deckState, updateDeckState];
}
